import { CardHeader, Typography } from '@mui/material';
import { sgrColors } from '../../../ui/sgr/SgrColors';
import { useTranslation } from 'react-i18next';

interface HeaderIconBoxProps {
  isSelected?: boolean;
  label: string;
}

const HeaderIconBox = (props: HeaderIconBoxProps) => {
  const { isSelected, label } = props;
  const { t } = useTranslation();

  return (
    <CardHeader
      sx={{
        p: 0,
        m: 0,
        color: isSelected ? sgrColors.azure : sgrColors.mine_shaft,
        transition: 'all 0.3s ease-in-out',
      }}
      title={
        <Typography
          variant="body1"
          children={t(label)}
          sx={{ fontWeight: isSelected ? 600 : 400 }}
        />
      }
    />
  );
};

export default HeaderIconBox;
